import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { addeventAPI, getAlleventssAPI, eventCustomersAPI } from '../api/event.service';
import moment from 'moment-timezone';
import { getDatesInRange} from '../utils/util';
export interface EventStatePayload {
  eventId?: string;
  eventDate: string;
  user_email:string;
  initialPrompt:string | null;
  initialTalk:string | null;
  scheduleDays: string;
  meetingDuration: string;
  meetingLocation: string;
  startTime: string;
  endTime: string;
  timezone: string;
  meetingLink: string;
  meetingLink1: string;
  meetingLink2: string;
  eventTitle: string;
  eventDescription: string;
  s3FileKey: string | undefined;
  unavailableDays: string[];
  unavailableDates: TimeRange[];
  unavailableTimeSlots: string[];
  voiceData: {
    voiceId: string;
    voiceName: string;
    stt: string;
    tts: string;
    language: string;
  } | null;

  digitalAvatar: {
    AvatarId: string;
    voiceId: string;
  } | null;
  
}
export interface InitialPromptPayload {
  prompt: string;
}
const defaultTimezone = moment.tz.guess();
export interface TimeRange {
  from: string;
  to: string;
}
interface EventState {
  data: EventStatePayload[] | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  payload:EventStatePayload,
  eventCustomers:[]
}

const initialState: EventState = {
  data: null,
  eventCustomers:null,
  status: 'idle',
  error: null,
  payload:{
    eventDate: '',
    user_email:'',
    scheduleDays: '15',
    meetingDuration: '15',
    meetingLocation: 'googleMeet',
    startTime: '09:30',
    endTime: '18:00',
    timezone: defaultTimezone,
    meetingLink:'',
    meetingLink2: '',
    meetingLink1: '',
    eventTitle: '',
    eventDescription: '',
    unavailableDays:[],
    unavailableDates: [],
    unavailableTimeSlots: [],
    s3FileKey: undefined,
    voiceData: null,
    digitalAvatar: null,
    initialPrompt: null,
    initialTalk: null
  }
};


export const addEvent = createAsyncThunk(
  'event/addEvent',
  async (eventData:EventStatePayload) => {
    const response = await addeventAPI(eventData);
    return response;
  }
);

export const fetchEvents = createAsyncThunk(
  'event/fetchEvents',
  async () => {
    const response = await getAlleventssAPI();
    return response.data;
  }
);

export const eventCustomers = createAsyncThunk(
  'event/eventCustomers',
  async () => {
    const response = await eventCustomersAPI();
    return response.data;
  }
);

export const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {

    setDefault: (state) => {
      state.payload ={
        eventDate: '',
        user_email:'',
        scheduleDays: '15',
        meetingDuration: '15',
        meetingLocation: 'googleMeet',
        startTime: '09:30',
        endTime: '18:00',
        timezone: defaultTimezone,
        meetingLink:'',
        meetingLink2: '',
        meetingLink1: '',
        eventTitle: '',
        eventDescription: '',
        unavailableDays:[],
        unavailableDates: [],
        unavailableTimeSlots: [],
        s3FileKey: undefined,
        voiceData: null,
        digitalAvatar: null,
        initialPrompt: null,
        initialTalk: null
      };
    },    
    setScheduleDay: (state, action: PayloadAction<string>) => {
      state.payload.scheduleDays = action.payload;
    },
    setMeetingDuration: (state, action: PayloadAction<string>) => {
      state.payload.meetingDuration = action.payload;
    },
    setMeetingLocation: (state, action: PayloadAction<string>) => {
      state.payload.meetingLocation = action.payload;
    },
    setStartTime: (state, action: PayloadAction<string>) => {
      state.payload.startTime = action.payload;
    },
    setEndTime: (state, action: PayloadAction<string>) => {
      state.payload.endTime = action.payload;
    },
    setTimezone: (state, action: PayloadAction<string>) => {
      state.payload.timezone = action.payload;
    },
    setMeetingLink1: (state, action: PayloadAction<string>) => {
      console.log( action.payload);
      state.payload.meetingLink1 = action.payload;
    },
    setMeetingLink2: (state, action: PayloadAction<string>) => {
      state.payload.meetingLink2 = action.payload;
    },
    setEventTitle: (state, action: PayloadAction<string>) => {
      state.payload.eventTitle = action.payload;
    },
    setEventDescription: (state, action: PayloadAction<string>) => {
      state.payload.eventDescription = action.payload;
    },
    sets3FileKey: (state, action: PayloadAction<string>) => {
      state.payload.s3FileKey = action.payload;
    },
    setInitialPrompt: (state, action: PayloadAction<string>) => {
      state.payload.initialPrompt = action.payload;
    },
    setInitialTalk: (state, action: PayloadAction<string>) => {
      state.payload.initialTalk = action.payload;
    },
    setVoiceData(state, action) {
      console.log(action.payload);

      state.payload.voiceData = {
        ...state.payload.voiceData,
        ...action.payload,
      };
      state.payload.digitalAvatar = null;
    },
    
    setDigitalAvatar(state, action) {
      state.payload.digitalAvatar = {
        AvatarId: action.payload.avatarId,
        voiceId: action.payload.voiceId,
      };
      state.payload.voiceData = null;
    },
    setUnavailableDays: (state, action: PayloadAction<{value:string, status:boolean}>) => {
      const { value, status } = action.payload;


      if (!value || value === '') {
        return;
      }
      const index = state.payload.unavailableDays.indexOf(value);
 
      if (status && index === -1) {
        state.payload.unavailableDays.push(value);
      } else  {
        state.payload.unavailableDays = state.payload.unavailableDays.filter(item => item !== value);
      } 
    },
    setUnavailableDates: (state, action: PayloadAction<TimeRange[]>) => {
      console.log(action.payload,'__action.payload');
      // getDatesInRange(action.payload[0].from, action.payload[0].to);
      state.payload.unavailableDates = action.payload;
    },
    setUnavailableTimeSlots: (state, action: PayloadAction<{value:string, status:boolean}>) => {
      const { value, status } = action.payload;
      if (!value || value === '') {
        return;
      }
      console.log(value);
      console.log(state.payload.unavailableTimeSlots);
      const index = state.payload.unavailableTimeSlots.indexOf(value);
      console.log(index);
      if (status && index === -1) {
        state.payload.unavailableTimeSlots.push(value);
      } else if (status && index !== -1) {
        state.payload.unavailableTimeSlots = state.payload.unavailableTimeSlots.filter(item => item !== value);
      }    
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(addEvent.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(addEvent.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // state.data = action.payload;
      })
      .addCase(addEvent.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Something went wrong';
      })
      .addCase(fetchEvents.pending, (state) => {
        state.status = 'loading';
      }).addCase(fetchEvents.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(eventCustomers.pending, (state) => {
        state.status = 'loading';
      }).addCase(eventCustomers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        
        state.eventCustomers = action.payload;
      })
  },
});
export const {
  setScheduleDay,
  setMeetingDuration,
  setMeetingLocation,
  setStartTime,
  setEndTime,
  setTimezone,
  setMeetingLink1,
  setMeetingLink2,
  setEventTitle,
  setEventDescription,
  sets3FileKey,
  setVoiceData,
  setDigitalAvatar,
  setUnavailableDays,
  setUnavailableDates,
  setUnavailableTimeSlots,
  setDefault,
  setInitialPrompt,
  setInitialTalk
} = eventSlice.actions;
export default eventSlice.reducer;
